var FormSubscribe = ( function($) {

    var FormSubscribe = function(options) {
        var that = this;

        // DOM
        that.$wrapper = options["$wrapper"];

        // INIT
        that.init(options);
    };

    var Self = FormSubscribe;
    Self.className = 'FormSubscribe';
    var Parent = FormAbstract;

    var def = FormAbstract.def;

    // "inherit"
    Self.prototype = Object.create(Parent.prototype);
    Self.prototype.constructor = Self;

    Self.prototype.init = function (options) {
        var that = this;

        options.onDoneSubmitCallback = function (response) {
            that.$wrapper.find('.js-form-subscribe').hide()
            that.$wrapper.find('.js-form-subscribe-agreement').hide()
            that.$wrapper.find('.js-success-result').show()
        }

        options.onAlertSubmitCallback = function (error) {
            that.$wrapper.find('.js-form-subscribe').hide()
            that.$wrapper.find('.js-form-subscribe-agreement').hide()
        }

        Parent.prototype.init.call(that, options);

        that.initInputMask()
    };

    Self.prototype.initVars = function (options) {
        var that = this;
        options = options || {};

        that.selectors = {
            form: '.js-form-subscribe',
            previous_action: '', //TODO: set this when other password restoration methods would be done
        };

        that.method = 'POST';

        that.url = def(options.url, '');
        that.has_success_screen = false;

        Parent.prototype.initVars.call(that, options);
        that.className = Self.className;
    };

    Self.prototype.initInputMask = function () {
        var that = this;

        UIInputMask.prototype.initEmailValidate(that.$wrapper)
    }

    return Self;
})(jQuery);